const deleteSubscriber = axios => {
  return axios.delete('subscribers');
};

const exportSubscriber = (axios, email) => {
  return axios.post('subscribers/export', { email });
};

const resetSubscriber = axios => {
  return axios.put('reset');
};

export {
  deleteSubscriber,
  exportSubscriber,
  resetSubscriber
};